module.exports = __webpack_public_path__ + "img/undraw_interests.8df37bdf.svg";